// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message-form":"message-form___trLbZ","row":"row___KQphi","full":"full___DxqeJ","half":"half___Wopwl"};